import repository from "@/api/modules/HR/Leaves/leaves";

export default {
  state: {
    leave_applications: [],
    leave_application_calendar: [],
    current_leave_application: null,
    leave_types: [],
    current_leave_type: null,
  },
  getters: {
    GET_LEAVE_APPLICATIONS: (state) => state.leave_applications,
    GET_LEAVE_APPLICATION_CALENDAR: (state) => state.leave_application_calendar,
    GET_CURRENT_LEAVE_APPLICATION: (state) => state.current_leave_application,
    GET_LEAVE_TYPES: (state) => state.leave_types,
    GET_CURRENT_LEAVE_TYPE: (state) => state.current_leave_type,
  },
  mutations: {
    SET_LEAVE_APPLICATIONS(state, payload) {
      state.leave_applications = payload;
    },
    SET_LEAVE_APPLICATION_CALENDAR(state, payload) {
      state.leave_application_calendar = payload;
    },
    SET_CURRENT_LEAVE_APPLICATION(state, payload) {
      state.current_leave_application = payload;
    },
    SET_LEAVE_TYPES(state, payload) {
      state.leave_types = payload;
    },
    SET_CURRENT_LEAVE_TYPE(state, payload) {
      state.current_leave_type = payload;
    },
    CLEAR_CURRENT_LEAVE_APPLICATION(state) {
      state.current_leave_application = null;
    },
  },
  actions: {
    // Leave Application Actions
    getLeaveApplications({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getLeaveApplications(payload)
          .then((response) => {
            if (response.status === 200) {
              commit("SET_LEAVE_APPLICATIONS", response.data);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getLeaveApplicationsCalendar({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getLeaveApplicationsCalendar(payload)
          .then((response) => {
            if (response.status === 200) {
              commit("SET_LEAVE_APPLICATION_CALENDAR", response.data);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    showLeaveApplication({ commit }, id) {
      return new Promise((resolve, reject) => {
        repository
          .showLeaveApplication(id)
          .then((response) => {
            if (response.status === 200) {
              commit("SET_CURRENT_LEAVE_APPLICATION", response.data);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    addLeaveApplication({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .addLeaveApplication(payload)
          .then((response) => {
            if (response.status === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    updateLeaveApplication({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .updateLeaveApplication(payload.id, payload.data)
          .then((response) => {
            if (response.status === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    updateLeaveApplicationStatus({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .updateLeaveApplicationStatus(payload.id, payload.data)
          .then((response) => {
            if (response.status === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    deleteLeaveApplication({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        repository
          .deleteLeaveApplication(id)
          .then((response) => {
            if (response.status === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // Leave Type Actions
    getLeaveTypes({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .getLeaveTypes(payload)
          .then((response) => {
            if (response.status === 200) {
              commit("SET_LEAVE_TYPES", response.data);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    showLeaveType({ commit }, id) {
      return new Promise((resolve, reject) => {
        repository
          .showLeaveType(id)
          .then((response) => {
            if (response.status === 200) {
              commit("SET_CURRENT_LEAVE_TYPE", response.data);
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    addLeaveType({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .addLeaveType(payload)
          .then((response) => {
            if (response.status === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    updateLeaveType({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        repository
          .updateLeaveType(payload.id, payload.data)
          .then((response) => {
            if (response.status === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    deleteLeaveType({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        repository
          .deleteLeaveType(id)
          .then((response) => {
            if (response.status === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    clearCurrentLeaveApplication({ commit }) {
      commit("CLEAR_CURRENT_LEAVE_APPLICATION");
    },
  },
};
